import stringify from 'json-stringify-safe';
import {
  BaseEvent,
  BasePlugin,
  BaseStats,
  EventIds,
  EventLevel,
  mergePluginOption,
  PlainObject,
} from '@fpkg/stats-core';
import { addEventListener, isUrlInIgnoreList } from '@fpkg/stats-utils';

export interface ResoureErrorOpt {
  // 指定忽略的资源路径,上报对应的静态资源错误。
  ignoreUrls?: (string | RegExp)[];
  event_level?: EventLevel; // 设置事件级别，error类型会上报顺丰云日志
}

/**
 * 获取dom上所有属性
 * @param dom
 * @return string
 */
const getAllAttrs = (dom: Element): string => {
  const attrs: PlainObject = {};
  for (let i = 0; ; i++) {
    const temp = dom.attributes[i];
    if (!temp) {
      return stringify(attrs);
    }
    attrs[temp.name] = temp.value;
  }
};

const getOnLine = () => {
  if ('onLine' in navigator) {
    return navigator.onLine ? 1 : 0;
  }
  return 2;
};

/**
 * 资源加载异常插件
 */
export default class ResourceErrorPlugin implements BasePlugin {
  name = 'resourceError';

  limit = 100;

  stats?: BaseStats;

  option: ResoureErrorOpt = {
    ignoreUrls: [],
  };

  constructor(option: ResoureErrorOpt | null | boolean) {
    mergePluginOption(this.option, option);
  }

  setup(stats: BaseStats) {
    this.stats = stats;

    addEventListener('error', this.captureResourceError.bind(this), true);
  }

  captureResourceError(event: Event, microApp?: string): BaseEvent | null {
    if (event instanceof ErrorEvent) return null;

    // 同一个页面最多上报100次，防止循环错误不断的报错
    if (this.limit-- < 0) return null;

    const target = (event.target || event.srcElement) as Element;
    // 资源地址
    const filename =
      target instanceof HTMLLinkElement ? target.href : (target as HTMLScriptElement | HTMLImageElement).src;
    if (isUrlInIgnoreList(filename, this.option.ignoreUrls)) {
      return null;
    }
    const eventInfo: BaseEvent = {
      event: EventIds.ResourceErrorInfo,
      filename,
      tag: target!.nodeName.toUpperCase(),
      attrs: getAllAttrs(target),
      performance_time: Math.round(performance.now()),
      is_online: getOnLine(),
      event_level: this.option.event_level || '',
    };

    if (microApp) {
      eventInfo.micro_app = microApp;
    }

    setTimeout(() => {
      // 5秒后上报，为了减少页面切换导致资源加载取消的情况。
      if (this.stats) {
        this.stats.event(eventInfo);
        this.stats.$bus.$emit('ON_RESOURCE_ERROR', eventInfo);
      }
    }, 5000);

    return eventInfo;
  }
}
